<fr-table [config]="tableConfig" [data]="tenantOffers" Id="offers-table">
</fr-table>

<fr-isc-form Id="manage-offers" [FDN]="FDN" [formModel]="data" [mode]="'edit'" [buttons]="buttons">
</fr-isc-form>